import React from "react";

const CircleLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] p-8">
      {/* Outer animated ring */}
      <div className="relative">
        {/* Pulsing ring */}
        <div className="w-20 h-20 rounded-full border-4 border-[#FDC700]/30 animate-ping absolute inset-0"></div>
        
        {/* Spinning ring */}
        <div className="w-20 h-20 rounded-full border-4 border-t-[#FDC700] border-r-[#FDC700] border-b-transparent border-l-transparent animate-spin"></div>
        
        {/* Inner logo circle */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 bg-gradient-to-br from-[#FDC700] to-yellow-500 rounded-xl flex items-center justify-center shadow-lg">
            <span className="text-white font-bold text-xl">G</span>
          </div>
        </div>
      </div>

      {/* Brand & loading text */}
      <div className="mt-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
          GALO HR TECH
        </h2>
        <div className="w-12 h-0.5 bg-[#FDC700] mx-auto my-2 rounded-full"></div>
        <div className="flex items-center gap-1 text-gray-500 text-sm font-medium">
          <span>Loading</span>
          <span className="flex gap-0.5">
            <span className="animate-bounce delay-0">.</span>
            <span className="animate-bounce delay-150">.</span>
            <span className="animate-bounce delay-300">.</span>
          </span>
        </div>
        {/* Optional: simulated progress indicator */}
        <div className="mt-4 w-48 h-1 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-[#FDC700] rounded-full w-2/3 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default CircleLoader;